import React, { ReactNode, useContext, useState } from "react";
import { UseCase, useCases } from "./useCases";

export type GuideState = {
  activeGuide?: UseCase;
};

export type GuideContextValue = {
  state: GuideState;
  openGuide: (useCase: UseCase) => void;
  closeGuide: () => void;
};

export const GuideContext = React.createContext<GuideContextValue>(null);

export const GuideProvider = function ({
  children = null,
}: {
  children?: ReactNode;
}) {
  const [state, setState] = useState<GuideState>({
    activeGuide: null,
  });
  return (
    <GuideContext.Provider
      value={{
        state,
        openGuide(useCase: UseCase) {
          setState((s) => ({ ...s, activeGuide: useCase }));
        },
        closeGuide() {
          setState((s) => ({ ...s, activeGuide: null }));
        },
      }}
    >
      {children}
    </GuideContext.Provider>
  );
};

export function useGuide() {
  return useContext(GuideContext);
}
